import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const PageContainer = styled.div`
  min-height: 100vh;
  padding: 40px 0;
  background: #eff3fe;

  ${theme.breakpoints.down('md')} {
    padding: 24px 0;
  }
`

export const PageGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 352px;
  gap: 48px;
  align-items: start;
  justify-content: center;

  ${theme.breakpoints.down('md')} {
    grid-template-columns: 1fr;
    gap: 32px;
  }
`

export const SuccessCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 0 0 40px 0;
  overflow: hidden;
  max-width: 770px;

  ${theme.breakpoints.down('md')} {
    padding: 0 0 32px 0;
    max-width: 100%;
  }
`

export const HeaderBadge = styled.div`
  background: #349a45;
  height: 64px;
  padding: 0 40px;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: white;

  ${theme.breakpoints.down('md')} {
    padding: 0 24px;
    margin-bottom: 32px;
  }
`

export const HeaderIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const HeaderText = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0;
  text-transform: uppercase;
`

export const ContentWrapper = styled.div`
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  gap: 32px;

  ${theme.breakpoints.down('md')} {
    padding: 0 24px;
    gap: 24px;
  }
`

export const SectionTitle = styled.h1`
  font-family: 'Inter', sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
  color: #262626;
  margin: 0 0 8px 0;

  ${theme.breakpoints.down('md')} {
    font-size: 20px;
  }
`

export const SectionSubtitle = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #666666;
  margin: 0;
`

export const InfoBanner = styled.div`
  background: #cceeff;
  border-radius: 6px;
  padding: 12px 16px;
  display: flex;
  gap: 12px;
  min-height: 56px;
  align-items: center;
`

export const InfoIconWrapper = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`

export const InfoText = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #262626;
`

export const ActionButton = styled.button`
  background: #0273ff;
  color: white;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  height: 40px;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.1s ease;
  width: 100%;
  max-width: fit-content;
  margin: 0 auto;
  display: block;

  &:hover {
    background: #0060e0;
  }

  &:active {
    transform: translateY(1px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  ${theme.breakpoints.down('md')} {
    width: 100%;
    max-width: 100%;
  }
`
